import LoaderShade from "../../../shared/components/loaderShade/loaderShade";

const TemplateSkeleton = () => {
   return (
      <>
         <div className="temp-summary-flex-container">
            <div className="d-flex align-items-center">
               <LoaderShade classname="sle-arow" />
            </div>
            <div className="temp-summary-title-text">
               <LoaderShade classname="temp-summary-title-sle" />
            </div>
            <div>
               <div className="item ">
                  <LoaderShade classname="toggle-sle" />
               </div>
            </div>
         </div>
         <div className="summary-para-text para-sle para-container-sle">
            <LoaderShade classname="para-sle " />
         </div>
         <div className="summary-container-sle">
            <div className=" summary-sle">
               <LoaderShade classname="summary-sle" />
            </div>
         </div>
      </>
   );
};

export default TemplateSkeleton;
